import { LiveTopic } from '../live-topics-types';

/**
 * Returns the display key points for a topic: refined_key_points when present and non-empty, otherwise key_points.
 */
export function getTopicDisplayKeyPoints(topic: LiveTopic): string[] {
  if (topic.refined_key_points?.length) {
    return topic.refined_key_points;
  }

  return topic.key_points ?? [];
}
